export default "__VITE_ASSET__BjS43Am7__"